import { EntityRepository, Repository } from "typeorm";
import { SoCustomerInvoice } from "../customer-invoice.entity";

@EntityRepository(SoCustomerInvoice)
export class CustomerInvoiceRepository extends Repository<SoCustomerInvoice> {


}
